import React from 'react';
import { useTheme } from '@mui/material';
import { VTypography } from '@venti-components';

const Installments = ({ installments }) => {
  const theme = useTheme();

  if (!installments || !installments.max || installments.max === 1) {
    return null;
  }

  const { max, hasInterest } = installments;

  const getInstallmentsText = () => {
    if (hasInterest) {
      return `Hasta ${max} cuotas`;
    }
    return `Hasta ${max} cuotas sin interés`;
  };

  return (
    <VTypography variant="body2" color={theme.palette.text.secondary}>
      {getInstallmentsText()}
    </VTypography>
  );
};

export default Installments;
